import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const FormError = ({ error }) => (
  <Error>
    *
    {error}
  </Error>
);

const Error = styled.span`
  color: red;
  font-size: 0.8rem;
  padding-top: 10px;
  font-weight: bold;
`;

FormError.propTypes = {
  error: PropTypes.string.isRequired,
};

export default FormError;
